import { render, staticRenderFns } from "./trxlistreport.vue?vue&type=template&id=68bf102f"
import script from "./trxlistreport.vue?vue&type=script&lang=js"
export * from "./trxlistreport.vue?vue&type=script&lang=js"
import style0 from "./trxlistreport.vue?vue&type=style&index=0&id=68bf102f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports